import { handleApi } from "../helpers/utility";
import axiosClient from "../helpers/axiosClient";

const BASE = 'trustscore/';

export async function fetchAllExperts(limit='', offset='', ordering='', filter, search) {
    return await handleApi(axiosClient.get(`${BASE}?is_active=true&limit=${limit}&offset=${offset}&ordering=${ordering}&search=${search}&${filter}`));
  }